<template>
  <v-card>
    <v-card-title>
      <v-icon left>mdi-trophy</v-icon>
      Project Parameters
    </v-card-title>
    <v-card-subtitle>
      Categorical and datum info regarding this project.
    </v-card-subtitle>
    <v-divider />
    <v-list>
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">fas fa-user</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ project.user.first_name }} {{ project.user.last_name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Technical Owner
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">fas fa-user</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            <div v-if="project.BDuser === null">
            No BD Owner
            </div>
            <div v-else>
              {{ project.BDuser.first_name }} {{ project.BDuser.last_name }}
            </div>
          </v-list-item-title>
          <v-list-item-subtitle>
            BD Owner
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-clock-start</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ project.created }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Created On
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-update</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ project.getLastModDate() }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Last Modified
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="red">mdi-timelapse</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ project.due_on }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Ship By
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <ProjectShippingDateEdit :current_date="project.due_on" :id="project.id" />
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-timetable</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ project.po_on }}
          </v-list-item-title>
          <v-list-item-subtitle>
            PO Date
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <ProjectPODateEdit :id="project.id" :current_date="project.po_on" />
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-timetable</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ project.material_on }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Materials Received On
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <ProjectMaterialsDateEdit :id="project.id" :current_date="project.material_on" />
        </v-list-item-action>
      </v-list-item>
      <v-divider />
      <v-list-item>
        <v-list-item-icon>
          <v-icon>{{ project.industry.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ project.industry.name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Project Category
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <IndustryFormEdit :instance="project.industry" />
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import IndustryFormEdit from "./IndustryFormEdit";
import ProjectMaterialsDateEdit from "./ProjectMaterialsDateEdit";
import ProjectPODateEdit from "./ProjectPODateEdit";
import ProjectShippingDateEdit from "./ProjectShippingDateEdit";
export default {
  name: "ProjectMilestones",
  components: { ProjectShippingDateEdit, ProjectPODateEdit, ProjectMaterialsDateEdit, IndustryFormEdit },
  props: {
    project: {
      type: Object,
      required: true
    }
  }
}
</script>
